/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAdjustmentsCancel = createReactComponent(
  "adjustments-cancel",
  "IconAdjustmentsCancel",
  [
    ["path", { d: "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", key: "svg-0" }],
    ["path", { d: "M6 4v4", key: "svg-1" }],
    ["path", { d: "M6 12v8", key: "svg-2" }],
    ["path", { d: "M13.499 14.675a2 2 0 1 0 -1.499 3.325", key: "svg-3" }],
    ["path", { d: "M12 4v10", key: "svg-4" }],
    ["path", { d: "M12 18v2", key: "svg-5" }],
    ["path", { d: "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", key: "svg-6" }],
    ["path", { d: "M18 4v1", key: "svg-7" }],
    ["path", { d: "M18 9v3", key: "svg-8" }],
    ["path", { d: "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-9" }],
    ["path", { d: "M17 21l4 -4", key: "svg-10" }]
  ]
);

export { IconAdjustmentsCancel as default };
//# sourceMappingURL=IconAdjustmentsCancel.js.map
